<template>
    <div class="bg">
        <div class="pc"></div>
        <div class="appb"></div>
    </div>
</template>
<script>
export default {
    data(){
        return{}
    }
}
</script>
<style lang="scss" scoped>
    .bg{
        width: 100vw;
        height: 100vh;
        background: url('../../../assets/img/expertImg/advertise_bg.png') no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
        position: relative;
    }
    .pc{
        width: 304px;
        height: 87px;
        background: url('../../../assets/img/expertImg/advertise_pc.png') no-repeat;
        background-size: 100% 100%;
        margin: 287px auto 0;
    }
    .appb{
        // width: 668px;
        width: 304px;
        height: 87px;
        background: url('../../../assets/img/expertImg/advertise_app.png') no-repeat;
        background-size: 100% 100%;
        margin: 7px auto 0;
        // position: absolute;
        // top: 395px;
        // left: 21px;
    }
</style>